<template>
  <a-modal
    v-model="imgVisible"
    :destroy-on-close="true"
    :footer="null"
    :width="width"
    :closable="closable"
    :maskClosable="false"
    centered
    class="zModal"
    @cancel="hide"
    :bodyStyle="bodyStyle"
  >
    <slot></slot>
    <span class="close-modal-icon" slot="closeIcon"></span>

  </a-modal>
</template>

<script>
export default {
  name: 'ZModal',
  data () {
    return {
      imgVisible: false
    }
  },
  props: {
    bodyStyle: {
      type: Object,
      default: () => {}
    },
    closable: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 480
    }
  },
  components: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    showModal () {
      this.imgVisible = true
    },
    hide () {
      this.imgVisible = false
    }
  }
}
</script>

<style lang="less">
.zModal {
  .update-title {
    color: #ff7401;
    font-size: 24px;
    text-align: center;
    padding: 38px 0 33px;
    line-height: 1;
  }
  .close-modal-icon {
    font-size: 18px;
    position: absolute;
    cursor: pointer;
  }
  .update-content {
    width: 650px;
    margin: 0 0 0 64px;
    height: 250px;
    overflow: auto;
    .desc {
      font-size: 16px;
      color: #333333;
      display: flex;
      line-height: 24px;
      margin-bottom: 13px;
      span {
        display: block;
        width: 644px;
      }
    }
  }
}

</style>
